
import { toDateTimeAttribute, toLocalDateTime } from '@/utils/localDate'

export default {
  name: 'ArticleByline',
  props: {
    publishedAt: {
      type: String,
      required: true,
    },
    modifiedAt: {
      type: String,
      default: '',
    },
    dateFormat: {
      type: String,
      default: 'PPP',
    },
  },
  methods: {
    toDateTimeAttribute,
    toLocalDateTime,
  },
}
